// components/ProtectedRoute.jsx
import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import sessionStore from '../stores/sessionStore' // Ваш M
import logger from '../utils/logger'

const ProtectedRoute = observer(({ children }) => {
	const isAuthenticated = !!sessionStore?.user // Проверяем, авторизован ли пользователь

	if (!isAuthenticated) {
		// Если пользователь не авторизован, перенаправляем на /login
		return <Navigate to='/login' replace />
	}

	// Если пользователь авторизован, отображаем дочерние компоненты
	return children
})

export default ProtectedRoute
